import JsonLoader from "./_jsonloader";
import Branch from "./_branch";
import Recommend from "./_recommend";
import ScrollEvent from "./_scrollevent";
import Intro from "../intro/main";

export default class Branches {
    constructor() {
        this._init();
    }

    _init() {
        this.books = {};
        this.createCount = 0;

        this.loader = new JsonLoader();
        this.loader.start(this._jsonLoaded.bind(this));
    }

    _jsonLoaded(books) {
        this.branchList = [];
        this.books = books;
        this._createBranch("s1");
        this._createBranch("s2", "r");
        this._createBranch("s3", "l");
        this._createBranch("chu");

        this.recommend = new Recommend();
        this.recommend.setup(this.books);

        this.intro = new Intro();
        this.intro.start(() => {});

        this.sce = new ScrollEvent();
        this.sce.start(this.branchList);
    }

    _createBranch(grade, overrideVect) {
        const datas = this.books[grade];
        if (datas.length == 0) return;

        const maxIndex = Math.ceil(datas.length / 5);
        const split = this._splitArray(datas, 5);

        for (let i = 0; i < maxIndex; i++) {
            const isTitle = i == 0 ? true : false;
            const branch = new Branch(split[i], ++this.createCount, grade, isTitle, overrideVect);
            this.branchList.push(branch);
        }
    }

    /**
     * n個づつ配列を分割する
     * @param array {Array} 分割もtの配列
     * @param n {int} 分割個数
     * @returns {Array}
     */
    _splitArray(array, n) {
        return array.reduce((a, c, i) => (i % n == 0 ? [...a, [c]] : [...a.slice(0, -1), [...a[a.length - 1], c]]), []);
    }
}
